import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHospitalDashboard } from "../../store/hospitalSlice";

const HospitalDashboard = () => {
  const dispatch = useDispatch();
  const { dashboard, status } = useSelector((state) => state.hospital);

  useEffect(() => {
    dispatch(fetchHospitalDashboard());
  }, [dispatch]);

  const hospital = dashboard?.hospital || {};
  const counters = dashboard?.counters || {};
  const recentJobs = dashboard?.recentJobs || [];

  return (
    <div className="col-lg-12">
      <div className="dashboard-inner">
        <div
          className="mb-25"
          style={{
            borderRadius: 10,
            padding: "14px 16px",
            border: hospital.isVerified ? "1px solid #1f9d55" : "1px solid #f0ad4e",
            background: hospital.isVerified ? "#ecfdf3" : "#fff9ec",
          }}
        >
          <strong style={{ marginRight: 8 }}>Verification Status:</strong>
          <span
            style={{
              fontWeight: 700,
              color: hospital.isVerified ? "#157347" : "#b36b00",
            }}
          >
            {hospital.isVerified ? "Verified" : "Pending Admin Verification"}
          </span>
        </div>

        <div className="author-and-action-btn-area two mb-40">
          <div className="author-area two">
            <div className="author-img">
              <img src={resolveHospitalLogo(hospital.logo)} alt={hospital.name || "Hospital"} />
            </div>
            <div className="author-content">
              <span>Hello,</span>
              <h4>{hospital.name || "Hospital"}</h4>
              <p>{hospital.email || ""}</p>
            </div>
          </div>
        </div>

        <div className="counter-area mb-40">
          <div className="row g-4">
            <div className="col-lg-4 col-sm-6">
              <div className="counter-single">
                <div className="coundown">
                  <p>Total Jobs</p>
                  <h3>{counters.totalJobs || 0}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="counter-single two">
                <div className="coundown">
                  <p>Live Jobs</p>
                  <h3>{counters.liveJobs || 0}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="counter-single three">
                <div className="coundown">
                  <p>Closed Jobs</p>
                  <h3>{counters.closedJobs || 0}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table-wrapper2">
          <div className="title-and-btn">
            <div className="title">
              <h4>Recent Hospital Jobs</h4>
            </div>
          </div>
          {status === "loading" ? (
            <p>Loading dashboard...</p>
          ) : (
            <table className="eg-table table job-list-table mb-0">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Department</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Posted</th>
                </tr>
              </thead>
              <tbody>
                {recentJobs.length === 0 ? (
                  <tr>
                    <td colSpan="5">No jobs posted yet.</td>
                  </tr>
                ) : (
                  recentJobs.map((job) => (
                    <tr key={job._id}>
                      <td>{job.title}</td>
                      <td>{job.department || "-"}</td>
                      <td>{job.location || "-"}</td>
                      <td>{job.status}</td>
                      <td>{new Date(job.createdAt).toLocaleDateString()}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default HospitalDashboard;
  const resolveHospitalLogo = (logo) => logo || "https://api.dicebear.com/9.x/shapes/svg?seed=Hospital";
